import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
} from '@angular/core';
import { MailingService } from './mailing-service.interface';

export const DataAccessMailingService = new InjectionToken<MailingService>(
  'MailingService',
);

export interface MailingServiceUseClass extends ClassSansProvider {
  useClass: Type<MailingService>;
}

export interface MailingServiceUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => MailingService;
}

export type MailingServiceProvider =
  | MailingServiceUseFactory
  | MailingServiceUseClass;

export function provideDataAccessMailingService(
  config: MailingServiceProvider,
) {
  return {
    provide: DataAccessMailingService,
    ...config,
  };
}
